import { LandingPage as LandingPageForm } from '@bgea-js/form-templates';
import customConfirmationEnSHIC from "../../../../src/content/free-shic-od/customConfirmation";
import "../../../../src/content/free-shic-od/shic-od-en.scss";
import * as React from 'react';
export default {
  LandingPageForm,
  customConfirmationEnSHIC,
  React
};